/** Outbound webhook delivery operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const WEBHOOK_ISSUES = {
  WEBHOOK_DELIVERY_FAILED: {
    category: ISSUE_CATEGORY.WEBHOOK,
    message: "Outbound webhook delivery failed (5xx, timeout, or connection refused)",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Webhook delivery failing",
    userGuidance:
      "Your webhook endpoint isn't accepting deliveries (server error, timeout, or refused connection). Check that the endpoint is online and reachable."
  },
  WEBHOOK_ENDPOINT_UNAUTHORIZED: {
    category: ISSUE_CATEGORY.WEBHOOK,
    message: "Outbound webhook endpoint returned 401 or 403",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Webhook endpoint rejecting auth",
    userGuidance:
      "Your webhook endpoint returned 401/403, so deliveries are being rejected. Verify the endpoint's authentication or signing secret."
  },
  WEBHOOK_ENDPOINT_RATE_LIMITED: {
    category: ISSUE_CATEGORY.WEBHOOK,
    message: "Outbound webhook endpoint is rate limiting requests",
    severity: "medium",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Webhook endpoint rate limiting",
    userGuidance:
      "Your webhook endpoint is rate-limiting Nexus (429). Raise its limit or slow consumption to avoid dropped deliveries."
  }
} as const satisfies Record<string, IssueDefinition>;
